import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { RunTag } from "@/components/RunTag";

export const TheDrop = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/drop")
      .then((res) => setItems(res.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      id="drop"
      data-testid="drop-section"
      className="relative mx-auto w-full max-w-[1400px] px-6 py-12 md:px-10 md:py-32"
    >
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="font-mono-stamp text-xs text-[#a0a0a0]">
            § 02 · DROP 001
          </span>
          <h2 className="font-display mt-4 text-6xl leading-[0.88] md:text-8xl">
            THE DROP
          </h2>
        </div>
        <p className="max-w-md font-mono-stamp text-xs leading-relaxed text-[#a0a0a0]">
          ONCE THEY'RE GONE, THEY'RE GONE. EVERY PIECE IS HAND-STAMPED WITH A
          RUN TAG. NEVER MADE EXACTLY THE SAME AGAIN.
        </p>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {loading &&
          Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="h-96 animate-pulse border border-[#222] bg-[#0c0c0c]"
            />
          ))}

        {!loading &&
          items.map((item) => {
            const remaining = item.run_size - item.run_sold;
            const pct = Math.round((item.run_sold / item.run_size) * 100);
            return (
              <Link
                to={`/drop/${item.id}`}
                data-testid={`drop-card-${item.id}`}
                key={item.id}
                className="group relative overflow-hidden border border-[#333] bg-[#0a0a0a] transition-colors hover:border-white"
              >
                <div className="relative aspect-[4/5] w-full overflow-hidden bg-black">
                  <img
                    src={item.image}
                    alt={item.name}
                    style={{ objectPosition: item.image_focus || "center" }}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute top-4 left-4 z-10">
                    <RunTag designNo={item.design_no} runNumber={`${String(item.run_sold + 1).padStart(3, "0")}/${item.run_size}`} />
                  </div>
                  <div className="absolute top-4 right-4 border border-white bg-black/70 px-2 py-1 font-mono-stamp text-[10px] text-white">
                    {remaining <= 5 ? "FINAL PIECES" : `${remaining} LEFT`}
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 flex h-[104px] flex-col justify-between border-t border-[#333] bg-black/80 px-4 py-3 backdrop-blur">
                    <div className="flex items-start justify-between gap-3">
                      <div className="min-w-0 flex-1">
                        <p className="font-mono-stamp text-[10px] text-[#a0a0a0]">
                          {item.category}
                        </p>
                        <h3 className="font-display mt-1 line-clamp-2 text-xl leading-[1.05] md:text-2xl">
                          {item.name.toUpperCase()}
                        </h3>
                      </div>
                      <span className="shrink-0 whitespace-nowrap font-mono-stamp text-xs text-[#a0a0a0]">
                        {item.tiers.length} TIERS · FROM ${Math.min(...item.tiers.map((t) => t.price))}
                      </span>
                    </div>
                    <div className="h-[2px] w-full bg-[#222]">
                      <div
                        className="h-full bg-white transition-all"
                        style={{ width: `${pct}%` }}
                      />
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
      </div>
    </section>
  );
};
